import React from 'react';
import {
  Box, IconButton, Typography,
} from '@mui/material';
import { observer } from 'mobx-react';
import { DiscountDto, DiscountDtoTypeEnum } from '@coretava/api/ecommerce-service';
import Close from '@mui/icons-material/Close';
import { Trans } from '@gamiphy/react-i18n';
import Color from 'color';
import { useMobile } from '@gamiphy/loyalty-station-desktop/utils/mobile';
import { WheelStore } from '@gamiphy/loyalty-station-desktop/store/campaignUsers/wheel';
import { formatDiscountValue } from '@gamiphy/loyalty-station-desktop/components/cashback';
import { CashbackPopupsStore } from '@gamiphy/loyalty-station-desktop/store/cashbackPopups';
import { CongratsActions, useDiscountDescription } from '@gamiphy/loyalty-station-desktop/components/cashback/campaigns/wheel';
import gift from './assets/gift.png';
import celebration from './assets/celebration.png';

const Congratulations: React.FC<{
  discount: DiscountDto,
}> = ({
  discount,
}) => {
  const isMobile = useMobile();

  const optionImage = React.useMemo(
    () => WheelStore.wheel?.wheelOptions.find((option) => option.id === discount.reference?.wheelOptionId)?.image,
    [WheelStore.wheel, discount],
  );

  const description = discount ? useDiscountDescription(discount) : undefined;

  const title = React.useMemo(() => {
    switch (discount.type) {
      case DiscountDtoTypeEnum.FreeShipping:
        return (
          <Typography fontSize="4.8rem" fontWeight={800} textAlign="center" lineHeight={1} color="primary" zIndex={1}>
            <Trans
              i18nKey="level.freeShipping.break"
              defaults="Free<br/>Shipping"
            />
            <Trans
              i18nKey="level.freeShipping.break"
              defaults="Free<br/>Shipping"
            />
          </Typography>
        );
      case DiscountDtoTypeEnum.FreeSku:
        return (
          <Box
            component="img"
            src={optionImage}
            maxWidth="40%"
            maxHeight={100}
          />
        );
      case DiscountDtoTypeEnum.Monetary:
      case DiscountDtoTypeEnum.Percentage:
        return formatDiscountValue(discount);
      default:
        return undefined;
    }
  }, [discount, optionImage]);

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? 'column' : 'row'}
      sx={{
        maxWidth: 850,
        height: isMobile ? '80%' : 400,
      }}
    >
      <Box
        width={isMobile ? '100%' : '50%'}
        height={isMobile ? '50%' : '100%'}
        position="relative"
        bgcolor="#fff"
        display="flex"
        justifyContent="center"
        alignItems="center"
        p={isMobile ? 2 : 3}
        sx={{
          ...isMobile && {
            minHeight: 200,
          },
        }}
      >
        {isMobile && (
        <IconButton
          sx={{
            ml: 'auto', p: 0, position: 'absolute', top: 16, right: 16,
          }}
          disableRipple
          onClick={() => CashbackPopupsStore.closeCashbackPopup()}
        >
          <Close fontSize="large" />
        </IconButton>
        )}
        <Box component="img" sx={{ position: 'absolute', left: 0, bottom: 0 }} src={gift} width="60%" />
        <Box component="img" sx={{ position: 'absolute', top: 10 }} src={celebration} width="70%" />
        {title}
      </Box>
      <Box
        p={isMobile ? 2 : 3}
        width={isMobile ? '100%' : '50%'}
        height={isMobile ? '50%' : '100%'}
        position="relative"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="flex-start"
        bgcolor={(th) => Color(th.palette.primary.main).alpha(0.1).hexa()}
      >
        {!isMobile && (
          <IconButton
            sx={{
              ml: 'auto', p: 0, position: 'absolute', top: 16, right: 16,
            }}
            disableRipple
            onClick={() => CashbackPopupsStore.closeCashbackPopup()}
          >
            <Close fontSize="large" />
          </IconButton>
        )}
        <Typography width="100%" fontSize={isMobile ? '1.8rem' : '3.2rem'} textAlign={isMobile ? 'center' : 'left'} fontWeight={700} color="primary" textTransform="uppercase" whiteSpace="nowrap" lineHeight={1}>
          <Trans
            i18nKey="campaigns.boosters.referral.widget.congrats"
            defaults="Congratulations! 🎉"
          />
        </Typography>
        <Typography fontSize="1.8rem" mt={2} textAlign={isMobile ? 'center' : 'left'}>
          {description}
        </Typography>
        <Box width="100%" mt={1}>
          <CongratsActions discount={discount} />
        </Box>
      </Box>
    </Box>
  );
};
export default observer(Congratulations);
